export const firefliesStorageKey = 'neo-fireflies-settings';
